import { render, staticRenderFns } from "./SenderSelect.vue?vue&type=template&id=009871bd&"
import script from "./SenderSelect.vue?vue&type=script&lang=js&"
export * from "./SenderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports